import React, { memo, useRef } from "react";
import "./ManageCapacityCard.scss";
import {
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonBadge,
  IonCard,
  IonButton,
  IonSpinner,
} from "@ionic/react";
import { Anywhere } from "../../../utils/constants";
import { formatStatesList } from "../../../pages/Manage/ManageCapacity/ManagaCapacityUtil";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import {
  getCapacityLoads,
  getCapacityLoadsSuccess,
  setCapacityToSeeResult,
  setManageSegmentSelected,
} from "../../../actions/manage/action";
import { CapacityModel } from "../../../models/manage/capacity.model";
import renderRawDate from '../../../utils/CapacityDate'
import * as Constants from "../../../utils/constants";
import { useState,useEffect } from "react";
import { capacity_see_result } from "../../../utils/Deadhead";

const ManageCapacityCardDetails: React.FC<any> = memo((props: any) => {

  const { states, isDestination } = props;
  return (
    <IonRow class="stop-details-row">
      <IonCol class="stop-icon-col">
        <IonImg className="ellipse_icon" src={`assets/icon/${props.icon}`} />
        {props.isOrigin ? <div className="stops_border"></div> : null}
      </IonCol>
      <IonCol class="stop-details-col capacity">
        <p
          className={`origin_city ${(isDestination && states && states.length > 0) || !props.radius
            ? "states-active"
            : ""
            }`}
        >
          {isDestination && states && states.length > 0
            ? states.join(", ")
            : props.city === Anywhere || props.city === null
              ? Anywhere
              : `${props.city}, ${props.state}`}
        </p>
        {!states ||
          (isDestination && states && states.length === 0 && props.radius) ||
          props.isOrigin ? (
            <IonBadge className="originRadius">{props.radius} miles</IonBadge>
          ) : null}
        {props.isTruck ? (
          <IonBadge className="pickupDate">
            {
              props.fromDate && props.toDate ? `${renderRawDate(props.fromDate, false, false)} - ${renderRawDate(props.toDate, false, false)}` : null
            }
          </IonBadge>
        ) : null}
      </IonCol>
    </IonRow>
  );
});

export const ManageCapacityCard: React.FC<any> = ({
  data,
  handleDelete,
  handleViewClick,
  hideSeeResult,
  userDetails,
  segmentselected
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoader,setIsLoader] = useState(false);
  const mounted = useRef(false);

  const details = [
    {
      icon: "origin-pointer.svg",
      ...data.origin,
      fromDate: data.pickUpFromDate,
      toDate: data.pickUpToDate,
      isOrigin: true,
      isTruck: data.capacityType.toLowerCase() === "truck",
    },
    {
      icon: "dst-pointer.svg",
      ...data.destination,
      isDestination: true,
      states: formatStatesList(data.destinationStates),
    },
  ];

  const handleDeleteClick = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    handleDelete(data);
    if (history.location.pathname == "/app/manage-capacity/see-results") {
      history.push("/app/manage-capacity");
    }
  };
  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(()=>{
    (!data.isLoadCountAvailable) && onSeeResult(null)
  },[data.isLoadCountAvailable])
  

  const onSeeResult = (
    event:
      | React.MouseEvent<HTMLIonButtonElement, MouseEvent>
      | React.MouseEvent<HTMLIonCardElement, MouseEvent>
      | any 
  ) => {
    event && event.preventDefault();
    event && event.stopPropagation();
    if(history.location.pathname==="/app/manage-capacity"){
    setIsLoader(true)
    const capacityModel = new CapacityModel();
    const query = capacityModel.getCapacityLoad(
      data.capacityId,
      (userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn) || "",
      Constants.pickUpStartDate,
      Constants.SORTING_ORDER_ASC,
      0,
      Constants.CAPACITY_LOADS_PAGESIZE,
    );
    const callback = () => {
      mounted.current && setIsLoader(false);
    };
    dispatch(getCapacityLoads({ query, callback }));
  }
  };

  const onSeeResultClick = () => {
    let {loadPostings,...rest} = data
    let temp = {
      loadPostings,
      capacity:rest
    }
    dispatch(getCapacityLoadsSuccess({
      data:temp,
      isPagination:false
    }));
    dispatch(
      setCapacityToSeeResult({
        data,
        handleDelete,
        handleViewClick,
        hideSeeResult: true,
      })
    );
    dispatch(setManageSegmentSelected(segmentselected));
    if(history.location.pathname !== capacity_see_result) {
    history.push(capacity_see_result);  
    }
  }
  const ResultsButtonText = (data.loadCount || 0) > 0 ? "See ("+ data.loadCount.toString() +") Results": "See Results" 
  return (
    <IonCard
      data-test="capacity-card"
      className="manage-capacity-card"
      onClick={() => {(data.loadCount || 0) > 0 && onSeeResultClick(); }}
    >
      <IonCardContent className="manage-capacity-card-content">
        <IonGrid className="manage-capacity-card-grid">
          <IonRow>
            <IonCol className="card-price-col" size="3">
              <p className="capacity-type">{data.capacityType.toLowerCase()}</p>
              <p className="trailer-type">{data.trailerType}</p>
            </IonCol>
            <IonCol className="card-city-col" size="5.5" size-lg="6">
              {details.map((detail: any, index: number) => (
                <ManageCapacityCardDetails
                  {...detail}
                  key={`details_${data.capacityId}_${index}`}
                  segmentselected={segmentselected}
                />
              ))}
            </IonCol>
            <IonCol className="card-action-col" size="3.5" size-lg="3">
             {(data.isLoadCountAvailable && (data.loadCount || 0) > 0) &&
                <IonButton
                  className='secondary-cta-btn-web'
                  onClick={onSeeResultClick}
                  style={{ display: `${hideSeeResult ? "none" : "block"}` }}
                  disabled={isLoader}
                >
                  {ResultsButtonText}
                </IonButton>}
                {(!data.isLoadCountAvailable && isLoader) && <IonSpinner/>}
              <IonButton
                className="capacity-actions-delete"
                onClick={handleDeleteClick}
              >
                <IonImg
                  className="star_icon delete-icon"
                  data-test="capacity-card-delete"
                  src="assets/icon/Delete_bin.svg"
                />
                <span className="btn-text">Delete</span>
              </IonButton>

              <IonButton
                className="capacity-actions-view"
                onClick={(
                  event: React.MouseEvent<HTMLIonButtonElement, MouseEvent>
                ) => {
                  handleViewClick(data);
                  dispatch(setManageSegmentSelected(segmentselected));
                  event.stopPropagation();
                  event.preventDefault();
                }}
              >
                <IonImg
                  className="star_icon view-icon"
                  data-test="capacity-card-delete"
                  src="assets/icon/view icon.svg"
                />
                <span className="btn-text">View</span>
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};
